module.exports = __webpack_public_path__ + "static/media/paint7.355856c0.jpg";